// Enabled by default; set the build-time flag to false to hide the section.
export const coursesEnabled = process.env.REACT_APP_COURSES_ENABLED !== "false";
// Enables owned course data, requests and conversations for this customer brand.
export const courseApiEnabled = process.env.REACT_APP_COURSE_API_ENABLED === "true";
// Explicit opt-in: course pages can be previewed without exposing a live checkout.
export const coursePaymentsEnabled = process.env.REACT_APP_COURSE_PAYMENTS_ENABLED === "true";
